import { configureStore } from '@reduxjs/toolkit';
import OrdiniSlice from './slices/OrdiniSlice';
import RootSlice from './slices/RootSlice';
import StatisticheSlice from './slices/StatisticheSlice';
import CarrelloSlice from './slices/CarrelloSlice';
import ClientiSlice from './slices/ClientiSlice';
import LaboratorioSlice from './slices/LaboratorioSlice';
import StoricoCarrelloSlice from './slices/StoricoCarrelloSlice';
import DocumentiSlice from './slices/DocumentiSlice';
import CatalogoSlice from './slices/CatalogoSlice';
import ReportSlice from './slices/ReportSlice';
import CrmRootSlice from './slices/CrmRootSlice';
import ArchiviSlice from './slices/ArchiviSlice';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import MagazzinoSlice from './slices/MagazzinoSlice';
import ListinoSlice from './slices/ListinoSlice';
import ConfigurazioneSlice from './slices/ConfigurazioneSlice';
import AgendaOldSlice from './slices/AgendaOldSlice';
import CaricoSlice from './slices/CaricoSlice';
import ChiusuraCassaSlice from './slices/ChiusuraCassaSlice';
import AnalisiVisivaSlice from './slices/AnalisiVisivaSlice';
import {
  AppointmentsReducer,
  CreateLinkReducer,
  AppointmentFormReducer,
  CalendarsReducer,
  CalendarFiltersReducer,
} from '../calendar/pages/Calendars/store/CalendarStore';
import DefaultCalendarReducer from '../calendar/pages/Calendars/pages/Default/store';
import PersonalCalendarReducer from '../calendar/pages/Calendars/pages/Personal/store';
import StudioCalendarReducer from '../calendar/pages/Calendars/pages/Studio/store';
import UserCalendarReducer from '../calendar/pages/Calendars/pages/User/store';
import NotificationsReducer from '../calendar/pages/Notifications/store/Notifications';
import { RotaRoot, RotaImport } from '../calendar/pages/Rota/store';
import {
  GeneralHoliday,
  GeneralRoot,
} from '../configurazione/Agenda/store/General';
import ServiceForm from '../configurazione/Services/store/form';
import ServiceRoot from '../configurazione/Services/store/root';
import { StudioRoot, StudioForm } from '../configurazione/Studi/store';
import {
  PointOfSaleRoot,
  PointOfSaleDefaultHours,
  PointOfSaleExtraHours,
} from '../configurazione/PointOfSales/store';
import {
  UserRoot,
  UserDefaultHours,
  UserExtraHours,
} from '../configurazione/Users/store';
import {
  LayoutRoot,
  LayoutPalette,
  LayoutFont,
  LayoutComponents,
  LayoutCustomTheme,
} from '../configurazione/Layout/store';
import StoreSlice from './slices/StoreSlice';

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
  reducer: {
    agendaold: AgendaOldSlice,
    analisiVisiva: AnalisiVisivaSlice,
    root: RootSlice,
    statistiche: StatisticheSlice,
    ordini: OrdiniSlice,
    cliente: ClientiSlice,
    carrello: CarrelloSlice,
    laboratorio: LaboratorioSlice,
    storicocarrello: StoricoCarrelloSlice,
    documenti: DocumentiSlice,
    catalogo: CatalogoSlice,
    report: ReportSlice,
    crmroot: CrmRootSlice,
    archivi: ArchiviSlice,
    magazzino: MagazzinoSlice,
    listino: ListinoSlice,
    configurazione: ConfigurazioneSlice,
    carico: CaricoSlice,
    chiusuracassa: ChiusuraCassaSlice,
    store: StoreSlice,

    bluBookingaAppointments: AppointmentsReducer,
    bluBookingCreateLink: CreateLinkReducer,
    bluBookingAppointmentForm: AppointmentFormReducer,
    bluBookingCalendars: CalendarsReducer,
    bluBookingCalendarFilters: CalendarFiltersReducer,
    bluBookingDefaultCalendar: DefaultCalendarReducer,
    bluBookingPersonalCalendar: PersonalCalendarReducer,
    bluBookingStudioCalendar: StudioCalendarReducer,
    bluBookingUserCalendar: UserCalendarReducer,
    bluBookingNotifications: NotificationsReducer,

    rotaRoot: RotaRoot,
    rotaImport: RotaImport,

    bluBookingGeneral: GeneralRoot,
    bluBookingHoliday: GeneralHoliday,

    bluBookingServiceRoot: ServiceRoot,
    bluBookingServiceForm: ServiceForm,

    bluBookingStudioRoot: StudioRoot,
    bluBookingStudioForm: StudioForm,

    bluBookingPointOfSaleRoot: PointOfSaleRoot,
    bluBookingPointOfSaleDefaultHours: PointOfSaleDefaultHours,
    bluBookingPointOfSaleExtraHours: PointOfSaleExtraHours,

    bluBookingUserRoot: UserRoot,
    bluBookingUserDefaultHours: UserDefaultHours,
    bluBookingUserExtraHours: UserExtraHours,

    bluBookingLayoutRoot: LayoutRoot,
    bluBookingLayoutPalette: LayoutPalette,
    bluBookingLayoutFont: LayoutFont,
    bluBookingLayoutComponents: LayoutComponents,
    bluBookingLayoutCustomTheme: LayoutCustomTheme,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
